module.exports = __webpack_public_path__ + "static/media/trump7.54e3934f.jpg";